import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * Validator for number input fields.
 * Returns { number: true } if the value is not a valid number.
 * Allows empty string or null (for optional fields).
 * Accepts both dot and comma as decimal separator.
 */
export function numberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional fields
  }

  let value = control.value;

  // Accept both dot and comma as decimal separator
  if (typeof value === "string") {
    value = value.replace(",", ".");
  }

  return isNaN(Number(value)) ? { number: true } : null;
}
